import React, { Component } from 'react';
import { IRFIDCardsModalProps } from '../../types/propTypes/propTypes';
import { IRFIDcardsModalState } from '../../types/stateTypes/stateTypes';
import { IRFIDCards, IRFIDCardsList, IRFIDCardDetails } from '../../models/rfid-cards';
import DriverService from '../../services/driver/driver-service';
import StandardResponse from '../../models/standard-response';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import Table from '../../components/table/Table';
import { SubgridTable } from '../../components/table/SubgridTable';
import moment from 'moment';
import { Common } from '../../utils/constants';
import { regionDateAndTime } from '../../utils';

class RFIDCardsModal extends Component<IRFIDCardsModalProps, IRFIDcardsModalState> {
    private driverService: DriverService;
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            data: [],
            totalCount: 0,
            childGridIndex: null,
            rfidCardId: null,
            currentPage: 1,
            rowsPerPage: 10,
            offset: 0,
            childGridState: {
                columns: [],
                currentPage: 1,
                data: [],
                offset: 0,
                rowsPerPage: 10,
                sortColumn: 'event_date',
                sortOrder: 'desc',
                totalCount: 0,
            },
        };
        this.driverService = new DriverService();
    }
    async componentDidMount() {
        const { t } = this.props;

        const header = [
            {
                label: t('RFIDCards.label.public_card_id'),
                id: 'public_card_id',
                sortable: false,
                isVisible: true,
                cell: (row: IRFIDCards) => {
                    return (
                        <span className="d-block text-truncate" style={{ maxWidth: 150 }} title={row.public_card_id}>
                            {row.public_card_id}
                        </span>
                    );
                },
            },
            {
                label: t('RFIDCards.label.mifare_uid'),
                id: 'mifare_uid',
                sortable: false,
                isVisible: true,
                cell: (row: IRFIDCards) => {
                    return (
                        <span className="d-block text-truncate" style={{ maxWidth: 150 }} title={row.public_card_id}>
                            {row.mifare_uid}
                        </span>
                    );
                },
            },
            {
                label: t('RFIDCards.label.status'),
                id: 'status',
                sortable: false,
                isVisible: true,
                style: { textAlign: 'center' },
                cell: (row: IRFIDCards) => {
                    return (
                        <span className="badge badge-info" style={{ background: row.status.color }}>
                            {row.status.name}
                        </span>
                    );
                },
            },
        ];
        const childGridHeader = [
            {
                label: t('RFIDCards.rfidDetails.label.event_date'),
                id: 'created_date',
                sortable: false,
                isVisible: true,
                cell: (row: IRFIDCardDetails) => {
                    if (row.created_date) {
                        return moment(row.created_date).format(regionDateAndTime().GENERAL_DATE_TIME_FORMAT);
                    }
                    return null;
                },
            },
            {
                label: t('RFIDCards.rfidDetails.label.chargeLocation'),
                id: 'charge_location_name',
                sortable: false,
                isVisible: true,
                cell: (row: IRFIDCardDetails) => {
                    return (
                        <span
                            className="d-block text-truncate"
                            style={{ maxWidth: 150 }}
                            title={row.charge_location_name}
                        >
                            {row.charge_location_name}
                        </span>
                    );
                },
            },
            {
                label: t('RFIDCards.rfidDetails.label.charge_station_name'),
                id: 'charge_station_name',
                sortable: false,
                isVisible: true,
                cell: (row: IRFIDCardDetails) => {
                    return (
                        <span
                            className="d-block text-truncate"
                            style={{ maxWidth: 150 }}
                            title={row.charge_station_name}
                        >
                            {row.charge_station_name}
                        </span>
                    );
                },
            },
            {
                label: t('RFIDCards.rfidDetails.label.response_status'),
                id: 'response_status',
                sortable: false,
                isVisible: true,
                cell: (row: IRFIDCardDetails) => {
                    return (
                        <span className="d-block text-truncate" style={{ maxWidth: 150 }} title={row.response_status}>
                            {row.response_status}
                        </span>
                    );
                },
            },
        ];

        const data = await this.getRFIDCardsList();

        this.setState({
            ...this.state,
            columns: header,
            data: data,
            childGridState: {
                ...this.state.childGridState,
                columns: childGridHeader,
            },
        });
    }

    handlePageChange = async (currentPage: number, rowsPerPage: number) => {
        const offset = (currentPage - 1) * rowsPerPage;
        this.setState(
            {
                currentPage: currentPage,
                rowsPerPage: rowsPerPage,
                offset: offset,
                childGridIndex: null,
                childGridState: {
                    ...this.state.childGridState,
                    data: [],
                    sortColumn: 'event_date',
                    sortOrder: 'desc',
                    offset: 0,
                    currentPage: 1,
                    rowsPerPage: 10,
                },
            },
            async () => {
                const list = await this.getRFIDCardsList();
                this.setState({
                    childGridState: {
                        ...this.state.childGridState,
                        data: list,
                    },
                });
            },
        );
    };

    getRFIDCardsList = async () => {
        const { id } = this.props;
        let rfidCardsList;
        let filterInput = {};
        Object.assign(filterInput, {
            limit: this.state.rowsPerPage,
            offset: this.state.offset,
        });
        await this.driverService
            .getRFIDCardsList(id, filterInput)
            .then(async (res: StandardResponse<IRFIDCardsList>) => {
                this.setState({
                    totalCount: res.Data.count,
                });
                rfidCardsList = res.Data.rows;
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return rfidCardsList;
    };

    getRFIDCardDetail = async () => {
        let driverId = this.props.id;
        let rfidCardId = this.state.rfidCardId;
        let rfidCardDetails;
        const filterInput = {};

        Object.assign(filterInput, {
            rfid_card_id: rfidCardId,
            limit: this.state.childGridState.rowsPerPage,
            offset: this.state.childGridState.offset,
        });

        await this.driverService
            .getRFIDCardDetails(driverId, filterInput)
            .then(async (res: StandardResponse<any>) => {
                rfidCardDetails = res.Data.rows;
                this.setState({ childGridState: { ...this.state.childGridState, totalCount: res.Data.count } });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return rfidCardDetails;
    };

    handleChildGridPaging = async (currentPage: number, rowsPerPage: number) => {
        const offset = (currentPage - 1) * rowsPerPage;
        this.setState(
            {
                childGridState: {
                    ...this.state.childGridState,
                    currentPage: currentPage,
                    rowsPerPage: rowsPerPage,
                    offset: offset,
                },
            },
            async () => {
                const list = await this.getRFIDCardDetail();
                this.setState({
                    childGridState: {
                        ...this.state.childGridState,
                        data: list,
                    },
                });
            },
        );
    };

    handleChildGridSorting = async (columnName: string) => {
        let sortOrder = this.state.childGridState.sortOrder;
        if (this.state.childGridState.sortColumn === columnName) {
            sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
        } else {
            sortOrder = 'asc';
        }
        this.setState(
            {
                childGridState: {
                    ...this.state.childGridState,
                    sortColumn: columnName,
                    sortOrder: sortOrder,
                },
            },
            async () => {
                const list = await this.getRFIDCardDetail();
                this.setState({
                    childGridState: {
                        ...this.state.childGridState,
                        data: list,
                    },
                });
            },
        );
    };

    handleChildGrid = async (index: number, row: any) => {
        let childgridIndex = this.state.childGridIndex !== index ? index : null;
        let rfidCardDetail = [];
        let rfidCardId = null;
        if (childgridIndex !== null) {
            rfidCardId = row.id;
        }
        this.setState(
            {
                ...this.state,
                rfidCardId: rfidCardId,
                childGridIndex: childgridIndex,
            },
            async () => {
                if (childgridIndex !== null) {
                    rfidCardDetail = await this.getRFIDCardDetail();
                }
                this.setState({
                    ...this.state,
                    childGridIndex: childgridIndex,
                    childGridState: {
                        ...this.state.childGridState,
                        data: rfidCardDetail,
                    },
                });
            },
        );
    };

    renderChildComponent = (): JSX.Element => {
        return (
            <Table
                data={this.state.childGridState.data}
                handlePageChange={this.handleChildGridPaging}
                columns={this.state.childGridState.columns}
                t={this.props.t}
                currentPage={this.state.childGridState.currentPage}
                handleSorting={this.handleChildGridSorting}
                rowsPerPage={this.state.childGridState.rowsPerPage}
                sortColumn={this.state.childGridState.sortColumn}
                sortOrder={this.state.childGridState.sortOrder}
                totalCount={this.state.childGridState.totalCount}
            ></Table>
        );
    };

    render() {
        const { t, showModal, closeModal } = this.props;
        return (
            <>
                <Modal className="set-rfid-modal-width" show={showModal} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('RFIDCards.header')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SubgridTable
                            columns={this.state.columns}
                            data={this.state.data}
                            rowsPerPage={this.state.rowsPerPage}
                            currentPage={this.state.currentPage}
                            totalCount={this.state.totalCount}
                            sortColumn={''}
                            sortOrder={''}
                            handlePageChange={this.handlePageChange}
                            handleSorting={() => {}}
                            t={this.props.t}
                            renderChildComponent={() => this.renderChildComponent()}
                            childGridIndex={this.state.childGridIndex}
                            handleChildGrid={this.handleChildGrid}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
export default RFIDCardsModal;
